import React from "react";
import type { FC, JSX, PropsWithChildren } from "react";

import classes from "./UniCellMiddle.styl";

export interface IContent extends PropsWithChildren {}

const UniCellMiddle: FC<IContent> = ({ children }): JSX.Element => {
    return (
        <div className={classes.middle} data-tsid="unicell-middle-test-id">
            {children}
        </div>
    );
};

UniCellMiddle.displayName = "UniCell.Middle";

export default UniCellMiddle;
